/* Font Weights */
export const Thin: number = 200;
export const Light: number = 300;
export const Normal: number = 400;
export const Medium: number = 500;
export const SemiBold: number = 600;
export const Bold: number = 700;
export const ExtraBold: number = 800;

/* Font sizes */
export const XXS: string = '12px';
export const XS: string = '14px';
export const SM: string = '16px';
export const MD: string = '18px';
export const LG: string = '20px';
export const XL: string = '22px';
export const XXL: string = '28px';
